import React, { useState } from "react";
import Select, { components } from "react-select";
import axios from "axios";
import colors from "../Constant/colors";

const CreateOpening = () => {
  const currentSessionId = localStorage.getItem("currentSessionId"); // session from localStorage

  const [jobTitle, setJobTitle] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [languagesKnown, setLanguagesKnown] = useState([]);
  const [education, setEducation] = useState("");
  const [experience, setExperience] = useState("");
  const [jobType, setJobType] = useState("");
  const [location, setLocation] = useState("");

  const languageOptions = [
    { value: "english", label: "English" },
    { value: "hindi", label: "Hindi" },
    { value: "spanish", label: "Spanish" },
    { value: "french", label: "French" },
  ];

  const jobTypeOptions = [
    { value: "full-time", label: "Full-Time" },
    { value: "part-time", label: "Part-Time" },
    { value: "contract", label: "Contract" },
    { value: "internship", label: "Internship" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentSessionId) {
      return alert("No active session found. Please select a session.");
    }

    const years = parseInt(experience) || 0;
    const formattedExperience = `${years} ${years === 1 ? "Year" : "Years"}`;

    const newOpening = {
      jobTitle,
      jobDescription,
      languagesKnown: languagesKnown.map((lang) => lang.label),
      education,
      experience: formattedExperience,
      jobType,
      location,
      sessionId: localStorage.getItem("currentSessionId"), // attach session ID automatically
    };

 try {
  await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/job-openings`,
    newOpening,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  );

  alert("Job Opening Created Successfully!");

  setJobTitle("");
  setJobDescription("");
  setLanguagesKnown([]);
  setEducation("");
  setExperience("");
  setJobType("");
  setLocation("");
} catch (error) {
  console.error(error);
  alert(error.response?.data?.error || "Error creating job opening");
}

  };

  const labelStyle = "block text-black font-semibold text-[18px] mb-1";

  const inputStyle = {
    width: "100%",
    padding: "12px",
    fontSize: "14px",
    border: "1px solid #1E40AF",
    borderRadius: "8px",
    boxSizing: "border-box",
  };

  const buttonStyle = {
    background: colors.gradientPrimary || "linear-gradient(to right, #4f46e5, #3b82f6)",
    color: "#fff",
    padding: "12px 24px",
    borderRadius: "8px",
    fontWeight: "600",
    cursor: "pointer",
    border: "none",
    fontSize: "18px",
  };

  const DropdownIndicator = (props) => <components.DropdownIndicator {...props} />;

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white">
      <div className="w-full max-w-4xl mx-auto">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className={labelStyle}>Job Title:</label>
            <input
              type="text"
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
              placeholder="Enter job title"
              style={inputStyle}
            />
          </div>

          <div>
            <label className={labelStyle}>Minimum Education:</label>
            <input
              type="text"
              value={education}
              onChange={(e) => setEducation(e.target.value)}
              placeholder="Enter minimum education"
              style={inputStyle}
            />
          </div>

          <div>
            <label className={labelStyle}>Experience Required:</label>
            <input
              type="number"
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
              placeholder="Enter experience"
              style={inputStyle}
            />
          </div>

          <div>
            <label className={labelStyle}>Job Type:</label>
            <Select
              options={jobTypeOptions}
              value={jobTypeOptions.find((opt) => opt.value === jobType)}
              onChange={(opt) => setJobType(opt.value)}
              placeholder="Select job type"
              components={{ DropdownIndicator }}
              styles={{ control: (base) => ({ ...base, border: "1px solid #1E40AF", fontSize: "14px" }) }}
            />
          </div>

          <div>
            <label className={labelStyle}>Location:</label>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="Enter location"
              style={inputStyle}
            />
          </div>

          <div className="md:col-span-2">
            <label className={labelStyle}>Languages Known:</label>
            <Select
              isMulti
              options={languageOptions}
              value={languagesKnown}
              onChange={setLanguagesKnown}
              placeholder="Select languages"
              components={{ DropdownIndicator }}
              styles={{ control: (base) => ({ ...base, border: "1px solid #1E40AF", fontSize: "14px" }) }}
            />
          </div>

          <div className="md:col-span-2">
            <label className={labelStyle}>Job Description:</label>
            <textarea
              rows="4"
              value={jobDescription}
              onChange={(e) => setJobDescription(e.target.value)}
              placeholder="Enter job description"
              style={inputStyle}
            />
          </div>

          <div className="md:col-span-2 mt-4">
            <button type="submit" style={buttonStyle}>Create Opening</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOpening;
